import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import HeroSection from '../components/home/HeroSection'
import CategoriesSection from '../components/home/CategoriesSection'
import FeaturedProducts from '../components/home/FeaturedProducts'
import SupplierSection from '../components/home/SupplierSection'
import FeaturesSection from '../components/home/FeaturesSection'
import TestimonialsSection from '../components/home/TestimonialsSection'
import CTASection from '../components/home/CTASection'
import { getFeaturedProducts } from '../services/api'

function HomePage() {
  const [featuredProducts, setFeaturedProducts] = useState({ products: [] })

  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        const products = getFeaturedProducts(8)
        setFeaturedProducts(products)
      } catch (error) {
        console.error('Error fetching featured products:', error)
        setFeaturedProducts({ products: [] })
      }
    }

    fetchFeaturedProducts()
  }, [])

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>1688Euro.com - Direkte Fabrikpreise aus China | B2B Großhandel & Import</title>
        <meta name="description" content="1688Euro.com - Direkter Import aus China zu Fabrikpreisen. Über 100 Millionen Produkte mit EU-Zollabwicklung. Handeln Sie direkt mit verifizierten Herstellern." />
        <meta name="keywords" content="1688Euro,1688Euro.com,China Import,Fabrikpreise,B2B Großhandel,Import China,EU Zollabwicklung,Hersteller China,Direktimport" />
        <link rel="canonical" href="https://1688euro.com/" />
      </Helmet>
      <HeroSection />
      <CategoriesSection />
      <FeaturedProducts products={featuredProducts.products} />
      <SupplierSection />
      <FeaturesSection />
      <TestimonialsSection />
      <CTASection />
    </div>
  )
}

export default HomePage